export default __webpack_public_path__ + "static/media/thirdyLogo.f11c876c.svg";